/*
* @Author: LiuMouLiang
* @Date:   2024-01-24
* 兼容老API, 移动端有些页面不能使用this.$get，为了统一，请求方法放在这边
*/
import fetch from '@/api/fetch';
import {
    _noValue,
    _toNumber,
    downloadBlob,
    getFileExtName,
    getFileName,
    _keyid,
    typeOf,
    getObjVal,
    awaitTo,
    setObjVal,
} from 'tools';
import {
    process_result,
    process_result_success,
    process_promise,
    getAppBqUrl,
    getUrl_APIURL,
    api_mock,
} from './util';
import {
    set_globalControlConfig_productMsg,
} from '_libs/util/control-use';
import {
    trace,
} from '_libs/util/base';
import {
    PERSONAL_INSURANCE_URL,
    env_stopSpecialIntercept,
} from '_libs/host';

// 用户信息
// export function getUserInfo(data) {
//     return new Promise((resolve, reject) => {
//         return fetch({
//             method: 'post',
//             url: `${TTTT}/api/group/getUserInfo`,
//             data,
//             headers:{
//                 "Authorization": cookie('token'),
//             },
//         }).then((res) => {
//             return process_result_success(res, resolve, reject);
//         }).catch(reject);
//     })
// };

// 产品详情 - 经纪
export function getjjProductDetail(productId) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL(`${api_mock}/insuranceChoose/${productId}`),
        params: {}
    }));
};

// 产品详情 - 科技
// export function getKjProductDetail(productId) {
//     return new Promise((resolve, reject) => {
//         return fetch({
//             method: 'get',
//             url: `${TTTT}/api/group/product/insuranceChoose/${productId}`,
//             params: {},
//             headers:{
//                 "Authorization": cookie('token'),
//             },
//         }).then((res) => {
//             return process_result_success(res, resolve, reject);
//         }).catch(reject);
//     })
// };

// 新版认证接口
export function getUserSalesQualification(params) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL(`getUserSalesQualification`),
        params,
        // headers:{
        //     "Authorization": cookie('token'),
        // },
    }));
};

// 查询banner接口
export function getBannerByType(type, productId) {
    const params = { type, insuraneType: 0 };
    if(productId) params['productId'] = productId;
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL(`conservation/getBannerByType`),
        params: params
    }));
};

// 获取推广费是否展示
export function getIsppshow(uuid) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL(`user/isppshow`),
        params: {
            u: uuid,
        }
    }));
};

// AC分离，是否认证状态获取
export function getPushMoneySwitchStatus(uuid) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL(`main/getPushMoneySwitchStatus`),
        params: {
        }
    }));
};


// 模糊查询团险产品也可全部 keyword
export function getQueryQroduct(keyword="") {
    return new Promise((resolve, reject) => {
        return fetch({
            method: 'get',
            url: '/api/getEffectiveProductList',
            params: {
                keyword,
            },
            // headers:{
            //     "Authorization": cookie('token'),
            // },
        }).then((res) => {
            const { data, resCode, code } = process_result(res);
            if(resCode === '000001' || code === 200) {
                resolve(data && data.map(it=>({...it, id: it.productId})));
            }else{
                reject(data || res);
            }
        }).catch(reject);
    });
};

//验证保全有效性
export const canApplyConservation = function(policyUuid) {
    return new Promise((resolve, reject) => {
        return fetch({
            method: 'get',
            url: `/api/conservation/canApplyConservation`,
            params: {
                policyUuid,
            },
            // headers:{
            //     "Authorization": cookie('token'),
            // },
        }).then((res) => {
            const { data, resCode } = process_result(res);
            if(resCode !== '000001' ) {
                reject();
                return false;
            }
            let msg = '';
            if(!data) msg = '验证保全有效性接口错误';
            else if(!data.canFlag) {
                // 跳转第三方流程
                if(data.isOutproduct && data.conservationUrl){
                    msg = '';
                    window.location.href = data.conservationUrl
                    reject();
                }else{
                    msg = data.msg || '正在保全，请勿重复发起，可前往保全列表查看';
                };
            }else if(data.msg){
                // 特殊数据，canFlag可以投保，但实际不可以投保
                // 同时如果成功则会msg为success
                // msg = data.msg;
            }
            resolve(msg);
        }).catch(reject);
    });
};

export function getPersonRiskInfo ({
    personInfoList,
    productId,
    groupOrderType,
}) {
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('getPersonRiskInfo'),
        data: {
            personInfoList,
            productId,
            groupOrderType,
        },
    }));
};

export function initThirdPremium ({
    policyUuid,
    conservationStartDateTime,
    updatedPersonOccuInfo,
}) {
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/initThirdPremium'),
        data: {
            policyUuid,
            conservationStartDateTime,
            updatedPersonOccuInfo,
        },
        brokerParams: {
            loadingParams: true,
        }
    }));
};

export function calcPremium (params = {}) {
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/calcPremium'),
        data: params,
    }));
};

export function getConservationConfig (productId) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('conservation/config'),
        params: {
            productId
        },
    }),(res)=>{
        const data = res.data || {};
        return set_globalControlConfig_productMsg(data, {type: 'bq'});
    });
};

// 线下录单 - 获取待处理的临时订单数据
export function getOfflineTempOrderData(params = {}) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('tmpOrder/getOfflineTempOrderData'),
        params,
    }));
};

// 线下录单 - 提交临时订单数据
export function submitOfflineTempOrder (data) {
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('tmpOrder/submitOfflineTempOrder'),
        data,
    }));
};

export function getSettingsByPolicyUuid({
    policyUuid,
    flowType, //1-全自动 || 0-半自动
    onlineFlag,
}) {
    if(_noValue(onlineFlag)) {
        onlineFlag = flowType ? true : false; //??暂定 -未知传参
    };
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('conservation/getSettingsByPolicyUuid'),
        params: {
            policyUuid,
            onlineFlag
        },
    }),(res)=>{
        const data = res.data || {};
        return set_globalControlConfig_productMsg(data, {type: 'bq'});
    });
};

export function getSettingsByConservationUuid(conservationUuid) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('conservation/getSettingsByConservationUuid'),
        params: {
            conservationUuid
        },
    }),(res)=>{
        const data = res.data || {};
        return set_globalControlConfig_productMsg(data, {type: 'bq'});
    });
};

export function canApplyConservationJobCode ({
    multiPlanJobPersonMap,
    policyUuid,
    updatedPersonOccuInfo,
    conservationJobDTO,
    productId,
    productCombId,
}) {
    if(productCombId){
        conservationJobDTO['productCombId'] = productCombId;
    }
    const params = {
        policyUuid,
        conservationJobDTO,
        // productCombId,
        productId: _toNumber(productId),
    };
    // if(updatedPersonOccuInfo) {
    //     params.updatedPersonOccuInfo = updatedPersonOccuInfo;
    // };
    // if(multiPlanJobPersonMap) {
    //     params.multiPlanJobPersonMap = multiPlanJobPersonMap;
    // };
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/canApplyConservationJobCode'),
        data: params,
        noErrMsg: true,
    }));
};

export const downloadConservationExcelNewTemp = async function(params){
    const [err, data] = await awaitTo(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/downloadConservationExcelNewTemp'),
        data: params,
        responseType: 'blob',
    }));
    const tt = typeOf(err), size = getObjVal(err,'size');
    if(tt == 'blob' && size){
        downloadBlob(err)
        return true;
    }else{
        return false;
    };
};

export const insureGroupUserRealNameLimit = function(productId){
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('insureGroupUserRealNameLimit'),
        params: {
            productId
        },
        noErrMsg: true,
    }));
};

export async function getConstructionAreaCode (productId) {
    const [err, res] = await awaitTo(fetch({
        method: 'get',
        url: getUrl_APIURL('getConstructionAreaCode'),
        params: {
            productId,
        },
    }));
    return err || {};
};

// 保全代理人和企业风控
export function riskLimitConservation(
    policyUuid,
    operationType
){
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/riskLimitConservation'),
        params: {
            policyUuid,
            operationType
        },
    }) )
}

export function getPolicyCheckMaterialInfo ({
    policyUuid,
}) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('order/getPolicyCheckMaterialInfo'),
        params: {
            policyUuid,
        },
    }));
};

export function uploadPolicyCheckMaterialInfo ({
    policyUuid,
    checkMaterialInfos
}) {
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('order/uploadPolicyCheckMaterialInfo'),
        data: {
            policyUuid,
            checkMaterialInfos
        },
    }));
};

export function getAllGroupProductFilterTag() {
    return process_promise(
        fetch({
            method: "get",
            url: getUrl_APIURL("getAllGroupProductFilterTag"),
        })
    );
}

export async function getAreaCode (productId) {
    const [err, res] = await awaitTo(fetch({
        method: 'get',
        url: getUrl_APIURL('getAreaCode'),
        params: {
            productId,
        },
    }));
    return res || {};
};

/* 保全校验人员信息-单个
【person】
birthDay
insuredIdNo
insuredIdType
insuredName
insuredSex
//额外添加
isHighJob
jobCode
occupationCode
productCombId
occupationType
*/
export function conservationVerifyPersonsInfo ({
    policyUuid,
    conservationStartDateTime,
    person,
}) {
    const params = {
        policyUuid,
        conservationStartDatetime: conservationStartDateTime, //大小写不一致
        person,
    };
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('conservation/verifyPersonsInfo'),
        data: params,
        noErrMsg: true,
    }));
};

/* 校验实人认证-验证人员有效性
【personInfoList】
cardType
idCardNo
name
*/
export async function realNameValidPersonInfo ({
    productId,
    personInfoList,
}) {
    let errMsg = '';
    const params = {
        productId,
        personInfoList,
    };
    const [err, res] = await awaitTo(fetch({
        method: 'post',
        url: getUrl_APIURL('validPersonInfo'),
        // baseURL: '',
        // url: '/mock/validPersonInfo',
        data: params,
    }));
    if(!res) {
        const errData = getObjVal(err,'data');
        const resCode = getObjVal(err,'resCode');
        // 和服务端确认只有服务端出现000002才有错误，其他都是正确的
        if(resCode === '000002' && typeOf(errData, 'array') && errData.length) {
            return {
                data: errData,
                type: 'valid-personInfo-popup', //错误人员列表
            };
        }
    };
    return errMsg;
};

//ebc4p4oj0719m4t8q990001p35
//Fj7dEbTchd94eLm7NetbitEcY7uu6zaNCNVoDfUUjw9m
export async function getOssToken (videoAuditToken) {
    return process_promise(fetch({
        method: 'get',
        url: `${PERSONAL_INSURANCE_URL}api/audit/getOssToken`,
        params: {
            videoAuditToken,
        },
    }));
};

export async function requestVideoAuditToken () {
    const [err, res] = await awaitTo(fetch({
        method: 'post',
        url: `${PERSONAL_INSURANCE_URL}api/audit/requestVideoAuditToken`,
    }));
    const token = getObjVal(res, 'data.token') || '';
    return token;
};

export function getInvoiceInfo ({
    policyUuid,
    orderType = 1, // 1-团险新单 2-保全订单
}) {
    let params = {
        policyUuid,
    };
    if(orderType === 2) {
        params['conservationUuid'] = policyUuid;
    };
    params['orderType'] = orderType;
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('invoice/getInvoiceInfo'),
        params,
    }));
};

export function getPremiumAndMissionConfig(productId) {
    // userPriceShow
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('product/getPremiumAndMissionConfig'),
        params: {
            productId
        },
    }),(res) => {
        if(env_stopSpecialIntercept) {
            setObjVal(res, 'data.userPriceShow', true);
        };
    });
};


export function getOfflineTempOrderDetail (offlineDataUuid) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('tmpOrder/getOfflineTempOrderDetail'),
        params: {
            offlineDataUuid,
        },
    }));
};

export function getClauseShowByPolicyUuid ({
    policyUuid,
    productId,
}) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('getClauseShowByPolicyUuid'),
        params: {
            policyUuid,
            productId,
        },
    }));
};


export async function getProductDictionaryDTOList (productId) {
    // 检查productId是否存在，如果不存在则直接返回一个空数组
    if(!productId) return [];
    // 使用awaitTo函数处理异步请求，fetch函数用于发送GET请求获取产品字典列表
    // awaitTo函数用于处理异步操作，返回一个包含错误和结果的数组
    const [err, res] = await awaitTo(fetch({
        method: 'get', // 请求方法为GET
        url: getUrl_APIURL('product/getProductDictionaryDTOList'), // 请求的URL，通过getUrl_APIURL函数获取
        params: {
            productId, // 请求参数，包含productId
        },
        loadingParams: 'no-loading' // 加载参数，表示不需要显示加载动画
    }));
    // 从响应结果中获取data字段，如果不存在则返回一个空数组
    const data = getObjVal(res, 'data') || [];
    // 返回获取到的数据
    return data;
};

// 更新保障责任接口
export async function insuranceInput(params){
    return process_promise(fetch({
        method: 'post',
        url: getUrl_APIURL('insurance/input'),
        data: params,
    }));
}


// 新算费接口
export async function calculationPremium(params){
    return process_promise(fetch({
        method: 'post',
        url: 'api/insurance/calculationPremium',
        data: params,
    }));
}

// 获取历史团体投保人信息
export function getHistoryGroupApplicantInfo (params = {}) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('order/getHistoryGroupApplicantInfo'),
        params,
    }));
};

// 根据订单uuid获取最新被保人员名单
export function getHistoryPolicyPersons(params = {}) {
    return process_promise(fetch({
        method: 'get',
        url: getUrl_APIURL('order/getHistoryPolicyPersons'),
        params,
    }));
};



// WEBPACK FOOTER //
// ./src/api/api.js